<template>
	<screen class="min-max-donation-view" institution="true">
		<template slot="logo">
			<img
				class="header-logo"
				:src="this.cause.icon"
				:style="{
					padding: this.cause.type == 'group' && '5px',
					background: this.cause.type == 'group' && 'white'
				}"
			/>
		</template>
		<template slot="org_name">
			<p
				style="
					font-size: 16px;
					color: white;
					margin-top: 3px;
					text-overflow: ellipsis;
				"
			>
				{{ this.cause.name }}
			</p>
		</template>
		<template slot="header">
			<ui-header type="dark" @click="onBack">
				<h2 slot="title">Set Donation Preferences</h2>
				Your donations will be calculated taking the designated minimum
				and maximum into account.
			</ui-header>
		</template>
		<form v-on:submit.prevent="onSubmit">
			<label>
				<ui-label v-if="minDonation" v-bind:style="{ fontSize: '10px' }"
					>Monthly Minimum Goal</ui-label
				>
				<ui-input
					placeholder="Minimum Donation"
					v-model="minDonation"
				/>
			</label>
			<label>
				<ui-label v-if="maxDonation" v-bind:style="{ fontSize: '10px' }"
					>Maximum Monthly Donation</ui-label
				>
				<ui-input
					placeholder="Maximum Donation"
					v-model="maxDonation"
				/>
			</label>
			<label>
				<div
					v-bind:style="{
						display: 'flex',
						flexDirection: 'row',
						justifyContent: 'space-between'
					}"
				>
					<ui-label
						v-if="wholeDollar"
						v-bind:style="{ fontSize: '10px' }"
						>Whole Dollar RoundUp Amount</ui-label
					>
					<ui-label
						@click="showInfo()"
						v-bind:style="{
							fontSize: '10px',
							flexGrow: 1,
							textAlign: 'right'
						}"
						class="roundup-info"
						>What is this?</ui-label
					>
				</div>
				<ui-input
					placeholder="Whole Dollar RoundUp Amount"
					v-model="wholeDollar"
				/>
			</label>
			<label>
				<br />
				<input type="checkbox" v-model="pauseDonation" /> Pause All
				Donations
				<br />
				<br />
			</label>
			<label>
				<ui-button native-type="submit" :loading="isLoading"
					>Save</ui-button
				>
			</label>
		</form>
		<modal v-model="showWholeDollar">
			<h3>What are Whole Dollar Roundups?</h3>
			<p>
				To maximize your impact for your organization, we round Whole
				Dollar Transactions (ie $1.00, $2.00, etc) to the next dollar.
				So a $4 transaction becomes $5.
			</p>
		</modal>
	</screen>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import UiButton from '../../ui/Button'
import UiLabel from '../../ui/Label'
import UiInput from '../../ui/Input'
import UiHeader from '../../ui/Header'
import Screen from '../../ui/Screen'
import Modal from '../../ui/Modal'

export default {
	name: 'min-max-donation-view',
	components: { UiButton, UiInput, UiHeader, Screen, Modal, UiLabel },
	data() {
		return {
			isLoading: false,
			minDonation: '10.00',
			maxDonation: null,
			pauseDonation: false,
			wholeDollar: '0',
			showWholeDollar: false
		}
	},
	computed: {
		...mapGetters(['user', 'cause']),
		minDonationInt() {
			this.minDonation = this.minDonation.replace(/[^0-9.]/g, '')
			if (!this.minDonation) {
				return null
			}
			return Math.round(this.minDonation.replace(/[^0-9.]/g, '') * 100)
		},
		wholeDollarInt() {
			if (!this.wholeDollar) {
				return null
			}
			return Math.round(this.wholeDollar.replace(/[^0-9.]/g, '') * 100)
		},
		maxDonationInt() {
			if (!this.maxDonation) {
				return null
			}
			return Math.round(this.maxDonation.replace(/[^0-9.]/g, '') * 100)
		}
	},
	methods: {
		...mapActions(['updateUser']),
		async onSubmit() {
			if (
				this.cause.type === 'group' &&
				(this.minDonationInt < 1000 || !this.minDonationInt)
			) {
				this.isLoading = false
				this.$swal(
					'Error',
					'In order to effectively support multiple organizations, we require a minimum goal of at least $10/month. That’s only around $0.33/day!'
				)
				return
			}
			if (!this.minDonationInt) {
				this.$swal('Error', 'Your monthly goal must be at least $1.00')
				return
			}
			if (this.minDonationInt > 4900) {
				this.isLoading = false
				const result = await this.$swal({
					title: `Confirm Monthly Minimum`,
					text: `$${this.minDonation} is very generous and ${this.cause.name} will be so grateful for your support! Please confirm to continue.`,
					showCancelButton: true,
					cancelButtonText: 'Cancel',
					allowOutsideClick: false,
					allowEscapeKey: false
				}).then((result) => {
					return result
				})
				if (result.dismiss === 'cancel') {
					return
				}
			}

			this.isLoading = true
			window.analytics.track('set_min_max', {
				min: this.minDonationInt,
				max: this.maxDonationInt,
				whole_dollar: this.wholeDollarInt
			})
			const user = {
				minimum_donation: this.minDonationInt,
				maximum_donation: this.maxDonationInt,
				is_donating: !this.pauseDonation,
				whole_transaction_amount: this.wholeDollarInt,
				email: this.user.email,
				phone: this.user.phone
			}
			this.updateUser(user)
				.then(() => {
					this.isLoading = false
					this.$swal(
						'Success',
						'Your donation preferences have been saved successfully.'
					)
				})
				.catch(({ message }) => {
					this.isLoading = false
					this.$swal('Error', message)
				})
		},
		onBack() {
			this.navigate({ name: 'settings' }, 'back')
		},
		showInfo() {
			this.showWholeDollar = true
		}
	},
	mounted() {
		this.minDonation = (this.user.minimum_donation / 100).toFixed(2)
		this.pauseDonation = !this.user.is_donating
		if (this.user.maximum_donation) {
			this.maxDonation = (this.user.maximum_donation / 100).toFixed(2)
		}
		this.wholeDollar = (this.user.whole_transaction_amount / 100).toFixed(2)
	}
}
</script>

<style lang="scss" scoped>
.min-max-donation-view {
	.roundup-info {
		font-size: 14px;
		color: $blue;
		cursor: pointer;
		&:hover {
			text-decoration: underline;
		}
	}
}

.screen {
	background: white;
}
</style>
